export default function TutorialCard({ id, title, watchUrl, src }) {
  const handleCardClick = () => {
    window.open(watchUrl, "_blank");
  };

  return (
    <div 
      onClick={handleCardClick}
      className="group flex flex-col bg-white rounded-2xl overflow-hidden border border-gray-300 transition-all duration-500 hover:-translate-y-1  cursor-pointer"
    >
      <div className="aspect-video relative bg-gradient-to-br from-gray-900 to-black overflow-hidden">
        <iframe
          className="absolute inset-0 w-full h-full opacity-95 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"
          src={src}
          title={title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>

        <a
          href={watchUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="absolute top-3 right-3 z-10 w-9 h-9 bg-black/60 hover:bg-red-600 backdrop-blur-md rounded-lg flex items-center justify-center text-white transition-all duration-300 transform hover:scale-110 opacity-0 group-hover:opacity-100"
          title="Open on YouTube"
          onClick={(e) => e.stopPropagation()}
        >
          <svg
            className="w-4 h-4 fill-current"
            viewBox="0 0 24 24"
          >
            <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"></path>
          </svg>
        </a>
      </div>

      <div className="p-5 bg-white border-t border-gray-100 group-hover:bg-orange-50/20 transition-colors duration-300">
        <div className="flex items-center gap-2 mb-3">
          <div className="w-6 h-6 bg-red-600 rounded-full flex items-center justify-center">
            <svg className="w-3 h-3 text-white" viewBox="0 0 24 24" fill="currentColor">
              <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
            </svg>
          </div>
          <p className="text-[11px] font-bold text-red-600 uppercase tracking-widest">
            YouTube
          </p>
        </div>
        <h3 className="text-sm font-bold text-gray-900 group-hover:text-orange-500 transition-colors duration-300 line-clamp-2 leading-relaxed">
          {title}
        </h3>
      </div>
    </div>
  );
}